import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader";
import SocieteService from "../../services/Societe";
import { useNavigate } from "react-router-dom";
import ErrorAlert from "../../components/layouts/ErrorAlert";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import SellingService from "../../services/SellingService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import FactureGroup from "../ProductSellBTOB/Table/FactureGroup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import UtilsFormule from "../../utils/UtilsFormule";
import SimulateRetenuVente from "../../components/finance/SimulateRetenuVente";
import SimulateRetenuByFacture from "../../components/finance/SimulateRetenuByFacture";

const PayementGroupe = ({ startLoading, stopLoading }) => {
  ////end retenu
  const animatedComponents = makeAnimated();

  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState("");
  const [idSociete, setIdSociete] = useState("any");
  const [options, setOptions] = useState([{ value: 0, label: "Tous" }]);
  const [yearsOptions, setYearsOptions] = useState([
    { value: "00", label: "Tous" },
  ]);
  const [monthsOptions, setMonthsOptions] = useState([
    { value: "00", label: "Tous" },
  ]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [finalYear, setFinalYear] = useState("");
  const [finalMonth, setFinalMonth] = useState("");
  const [yearPlaceholder, setYearPlaceholder] = useState("");
  const [monthPlaceholder, setMonthPlaceholder] = useState("");
  const [payedOrNotPayed, setPayedOrNotPayed] = useState("any");
  const [document, setDocument] = useState(null);
  const [listFacture, setListFacture] = useState([]);
  const [wallet, setWallet] = useState(null);

  const [selectedOptionDocument, setSelectedOptionDocument] =
    useState("Facture");
  const [selectedOptionPayement, setSelectedOptionPayement] = useState("Payed");
  useEffect(() => {
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          const today = new Date();
          const mm = String(today.getMonth() + 1).padStart(2, "0");
          const yyyy = today.getFullYear();

          setFinalYear(yyyy);
          setYearPlaceholder(yyyy);

          if (mm === "01") {
            setFinalMonth("01");
            setMonthPlaceholder("Janvier");
          } else if (mm === "02") {
            setFinalMonth("02");
            setMonthPlaceholder("Février");
          } else if (mm === "03") {
            setFinalMonth("03");
            setMonthPlaceholder("Mars");
          } else if (mm === "04") {
            setFinalMonth("04");
            setMonthPlaceholder("Avril");
          } else if (mm === "05") {
            setFinalMonth("05");
            setMonthPlaceholder("Mai");
          } else if (mm === "06") {
            setFinalMonth("06");
            setMonthPlaceholder("Juin");
          } else if (mm === "07") {
            setFinalMonth("07");
            setMonthPlaceholder("Juiliet");
          } else if (mm === "08") {
            setFinalMonth("08");
            setMonthPlaceholder("Aout");
          } else if (mm === "09") {
            setFinalMonth("09");
            setMonthPlaceholder("Septembre");
          } else if (mm === "10") {
            setFinalMonth("10");
            setMonthPlaceholder("Octobre");
          } else if (mm === "11") {
            setFinalMonth("11");
            setMonthPlaceholder("Novembre");
          } else if (mm === "12") {
            setFinalMonth("12");
            setMonthPlaceholder("Decemebre");
          }

          const yearsOptions = response.data["success"].years.map(
            (year, index) => ({
              value: year,
              label: year,
            })
          );
          setYearsOptions([{ value: "00", label: "Tous" }, ...yearsOptions]);

          const orderedMonth = response.data["success"].months.map((month) =>
            parseInt(month)
          );
          console.log(orderedMonth);
          orderedMonth.sort((a, b) => a - b);
          console.log(orderedMonth);

          const monthsOptions = orderedMonth.map((month) => {
            const monthLabel = month < 10 ? `0${month}` : `${month}`;
            switch (month) {
              case 1:
                return { value: monthLabel, label: "Janvier" };
              case 2:
                return { value: monthLabel, label: "Février" };
              case 3:
                return { value: monthLabel, label: "Mars" };
              case 4:
                return { value: monthLabel, label: "Avril" };
              case 5:
                return { value: monthLabel, label: "Mai" };
              case 6:
                return { value: monthLabel, label: "Juin" };
              case 7:
                return { value: monthLabel, label: "Juillet" };
              case 8:
                return { value: monthLabel, label: "Aout" };
              case 9:
                return { value: monthLabel, label: "Septembre" };
              case 10:
                return { value: monthLabel, label: "Octobre" };
              case 11:
                return { value: monthLabel, label: "Novembre" };
              case 12:
                return { value: monthLabel, label: "Decembre" };
              default:
                return null;
            }
          });

          console.log(monthsOptions);
          setMonthsOptions([{ value: "00", label: "Tous" }, ...monthsOptions]);
          // remplissageYearsAndMonthsOption();
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      });

    startLoading();
    SocieteService.getAllGroupe()
      .then((response) => {
        setOptions([{ value: 0, label: "Tous" }, ...response.data.success]);
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const onValueDocumentChange = (event) => {
    if (event.target.value === "BDC") {
      setDocument(0);
    } else if (event.target.value === "Facture") {
      setDocument(1);
    }
    setSelectedOptionDocument(event.target.value);
    console.log("selectedOptionDocument", event.target.value);
  };
  const saveIdSociete = async () => {
    try {
      // Fetch factures not paid by group
      const facturesResponse = await SellingService.getFacturesNotPayedByGroupe(
        getCurrentUserId(),
        selectedOption.value,
        selectedYear.value,
        selectedMonth.value
      );
      setListFacture(facturesResponse.data.success);
    } catch (error) {
      console.error("Error fetching factures:", error);
    }

    try {
      // Fetch wallet by group
      const walletResponse = await SellingService.getWalletByGroupe(
        getCurrentUserId(),
        selectedOption.value
      );
      setWallet(walletResponse.data.success);
    } catch (error) {
      console.error("Error fetching wallet:", error);
    }
  };
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setIdSociete(selectedOption.value);
  };

  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
    setFinalYear(selectedOption.value);
    console.log(`Option selected:`, selectedOption.value);
  };

  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
    setFinalMonth(selectedOption.value);
    console.log(`Option selected:`, selectedOption.value);
  };

  const onValueChange = (event) => {
    if (event.target.value === "Payed") {
      setPayedOrNotPayed(1);
    } else if (event.target.value === "NotPayed") {
      setPayedOrNotPayed(0);
    } else if (event.target.value === "All") {
      setPayedOrNotPayed("any");
    }
    setSelectedOptionPayement(event.target.value);
    // console.log("selectedOptionPayement", event.target.value);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      {alertMessage === "error" ? (
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <ErrorAlert message="Désolé aucun Société cliente à afficher, Vous devez ajouter une société svp" />
            </div>
          </div>
        </section>
      ) : (
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">Payement par groupe</h3>
                </div>
                <form
                  className="form-horizontal"
                  onSubmit={saveIdSociete}
                ></form>
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir le groupe</label>
                        <Select
                          value={selectedOption}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={options}
                          onChange={handleChange}
                          defaultValue={selectedOption}
                          placeholder={"Tous"}
                        />
                      </div>
                    </div>

                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir l'année </label>
                        <Select
                          value={selectedYear}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={yearsOptions}
                          onChange={handleYearChange}
                          defaultValue={selectedYear}
                          placeholder={yearPlaceholder}
                        />
                      </div>
                    </div>

                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir le mois</label>
                        <Select
                          value={selectedMonth}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={monthsOptions}
                          onChange={handleMonthChange}
                          defaultValue={selectedMonth}
                          placeholder={monthPlaceholder}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    onClick={saveIdSociete}
                    className="btn btn-dark float-right"
                  >
                    Valider
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <section className="m-2">
        {wallet && (
          <div className="info-box mb-3 bg-gray col-6">
            <span className="info-box-icon">
              <i className="fas fa-wallet icon-campagne mr-3"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text"> {wallet?.title} </span>
              <span className="info-box-text"> Solde </span>
              <span className="info-box-number">{wallet?.solde} DNT</span>
            </div>
          </div>
        )}
        {listFacture && listFacture.length > 0 && (
          <FactureGroup
            listFacture={listFacture}
            wallet={wallet}
          />
        )}
      </section>
    
    </div>
  );
};

export default withLoader(PayementGroupe);
